import './TagPills.css';

const TAG_BACKGROUNDS = {
  default: 'rgba(0, 211, 242, 0.5)',
  india: 'rgba(225, 42, 251, 0.5)',
  us: 'rgba(43, 127, 255, 0.3)',
};

const getTagBackground = (tag) => {
  const key = String(tag || '').trim().toLowerCase();
  return TAG_BACKGROUNDS[key] ?? TAG_BACKGROUNDS.default;
};

export default function TagPills({ tags = [], position = 'top', className = '' }) {
  if (!tags.length) return null;

  const classes = ['TagPills', position === 'bottom' ? 'TagPills--bottom' : 'TagPills--top', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      {tags.map((tag) => (
        <span
          key={tag}
          className="TagPills__tag"
          style={{ backgroundColor: getTagBackground(tag) }}
        >
          #{tag}
        </span>
      ))}
    </div>
  );
}
